/* eslint-disable */
import { createSelector } from 'reselect';

/**
 * Select a specific order
 * @param {any} orderId The order id
 * @returns {OrderEntity | null} The `order` that has been selected from the store
 */
const orderEntitySelector = (orderId) => (state) => state.orders.entities[orderId] || null;

/**
 * Creates a new selector for an order entity
 * @param {any} orderId The order id
 * @returns {Function} The `orders` that have been selected from the store
 */
const orderItemSelector = (orderId) => createSelector(orderEntitySelector(orderId), (order) => order);

export default orderItemSelector;
